import { render } from "./registrotrx.vue?vue&type=template&id=c95eaa2e&scoped=true"
import script from "./registrotrx.vue?vue&type=script&lang=js"
export * from "./registrotrx.vue?vue&type=script&lang=js"

import "./registrotrx.vue?vue&type=style&index=0&id=c95eaa2e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Public\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c95eaa2e"]])

export default __exports__